import { Link } from "react-router-dom";
import { ArrowUpRight, Play } from "lucide-react";
import { VIDEOS } from "../data/content";

function VideoCard({ video, index }) {
  const thumbId = video.embedUrl?.split("/embed/")[1];

  return (
    <Link
      to={`/videos/${video.id}`}
      className="blog-card-enter"
      style={{
        textDecoration: "none",
        display: "block",
        breakInside: "avoid",
        marginBottom: 16,
        animationDelay: `${index * 80}ms`,
      }}
    >
      <div
        style={{
          background: "#fff",
          border: "1px solid #E4E4E7",
          borderRadius: 16,
          overflow: "hidden",
          transition: "transform 280ms cubic-bezier(0.25,0.1,0.25,1), box-shadow 280ms cubic-bezier(0.25,0.1,0.25,1)",
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow = "0 20px 48px rgba(0,0,0,0.11)";
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = "";
          e.currentTarget.style.boxShadow = "";
        }}
      >
        {/* Thumbnail */}
        <div style={{ position: "relative", overflow: "hidden", background: "#0F172A" }}>
          {thumbId ? (
            <>
              <img
                src={`https://img.youtube.com/vi/${thumbId}/hqdefault.jpg`}
                alt={video.title}
                style={{ width: "100%", display: "block", transition: "transform 500ms cubic-bezier(0.25,0.1,0.25,1)" }}
                onMouseEnter={e => { e.currentTarget.style.transform = "scale(1.04)"; }}
                onMouseLeave={e => { e.currentTarget.style.transform = ""; }}
              />
              {/* Play overlay */}
              <div style={{
                position: "absolute", inset: 0,
                display: "flex", alignItems: "center", justifyContent: "center",
                background: "rgba(0,0,0,0.18)",
                transition: "background 200ms",
              }}
                onMouseEnter={e => { e.currentTarget.style.background = "rgba(0,0,0,0.35)"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "rgba(0,0,0,0.18)"; }}
              >
                <div style={{
                  width: 48, height: 48, borderRadius: "50%",
                  background: "rgba(255,255,255,0.92)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
                }}>
                  <Play size={18} color="#09090B" style={{ marginLeft: 3 }} />
                </div>
              </div>
              {/* Duration badge */}
              {video.duration && (
                <span style={{
                  position: "absolute", bottom: 10, right: 10,
                  background: "rgba(0,0,0,0.72)", color: "#fff",
                  fontFamily: "'Space Grotesk',sans-serif",
                  fontSize: 11, fontWeight: 700,
                  padding: "2px 7px", borderRadius: 4,
                  letterSpacing: "0.03em",
                }}>
                  {video.duration}
                </span>
              )}
            </>
          ) : (
            <div style={{ height: 200, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 52 }}>
              {video.emoji}
            </div>
          )}
        </div>

        {/* Content */}
        <div style={{ padding: "16px 16px 14px" }}>
          <h3 style={{
            fontFamily: "'Archivo',sans-serif",
            fontWeight: 700, fontSize: 14,
            color: "#09090B", lineHeight: 1.4,
            margin: "0 0 6px",
          }}>
            {video.title}
          </h3>
          <p style={{
            fontFamily: "'Space Grotesk',sans-serif",
            fontSize: 12, color: "#64748B",
            lineHeight: 1.6, margin: "0 0 12px",
            display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden",
          }}>
            {video.description}
          </p>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", paddingTop: 10, borderTop: "1px solid #F4F4F5" }}>
            <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, fontWeight: 700, color: "#2563EB", display: "flex", alignItems: "center", gap: 2 }}>
              Xem <ArrowUpRight size={12} />
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default function Videos() {
  return (
    <div style={{ maxWidth: 1100, margin: "0 auto", padding: "48px 24px 80px" }}>

      {/* Header */}
      <div className="reveal" style={{ marginBottom: 40 }}>
        <span className="section-label">Video</span>
        <h1 style={{
          fontFamily: "'Archivo',sans-serif",
          fontWeight: 900,
          fontSize: "clamp(28px,4vw,52px)",
          color: "#09090B",
          margin: "0 0 10px",
          letterSpacing: "-0.03em",
          lineHeight: 1.05,
        }}>
          Video Portfolio<br />
          <span style={{ color: "#2563EB" }}>AI-made</span>
        </h1>
        <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 15, color: "#64748B", margin: 0, maxWidth: 460, lineHeight: 1.65 }}>
          Những video quảng cáo tạo hoàn toàn bằng AI, từ concept đến output.
        </p>
      </div>

      {/* Masonry 2 columns */}
      <div className="video-masonry reveal reveal-delay-1">
        {VIDEOS.map((video, i) => (
          <VideoCard key={video.id} video={video} index={i} />
        ))}
      </div>

    </div>
  );
}
